import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 24,
  },
  side: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
}));

/**
 * Standard page title row. `quote` renders the brand tagline on the right;
 * `action` renders any custom node there instead (buttons, chips, etc.).
 */
const PageHeader = ({ title, quote, action }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} alignItems="center" className={classes.root}>
      <Grid item xs={12} sm={quote || action ? 6 : 12}>
        <Typography variant="h2">{title}</Typography>
      </Grid>
      {(quote || action) && (
        <Grid item xs={12} sm={6} className={classes.side}>
          {action || (
            <Typography variant="subtitle2">
              “{quote}” – Smart Squirrel
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default PageHeader;
